(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/app.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/app.js');

'use strict';

const Provider = svs.gamePackage.redux.Provider;
const GamePackagePage = svs.gamePackage.components.GamePackagePage;
const target = document.getElementById('ngGamePackage');
const App = () => React.createElement(Provider, null, React.createElement(GamePackagePage, null));
target && ReactDOM.render(React.createElement(App, null), target);

 })(window);